import { z } from "zod";
import { gql } from "graphql-request";

const RelatedMediaItemSchema = z.object({
  id: z.string(),
  title: z.string().optional(),
  label: z.string().optional(),
  image: z
    .object({
      id: z.string(),
      title: z.string(),
      width: z.number(),
      height: z.number(),
      url: z.string(),
    })
    .nullable()
    .optional(),
});

export const RelatedMediaSchema = z.object({
  relatedMedia: z.array(RelatedMediaItemSchema).nullable(),
});

export const RelatedMedia = RelatedMediaSchema;
export type RelatedMedia = z.infer<typeof RelatedMediaSchema>;
export type RelatedMediaItem = z.infer<typeof RelatedMediaItemSchema>;

export const RelatedMediaFragment = gql`
  fragment RelatedMediaFragment on RelatedMedia {
    relatedMedia
  }
`;
